// import { useEffect } from "react";
import useStore from "../hooks/useStore";
import Calendar from "./Calendar";
import WebinarDialog from "./WebinarDialog";
import Header from "./Header";

function App() {
  const isOpen = useStore((state) => state.isWebinarDialogOpen);
  const closeWebinarDialog = useStore((state) => state.closeWebinarDialog);
  const activeWebinar = useStore((state) => state.activeWebinar);

  return (
    <>
      <Header />
      <Calendar />
      {!!activeWebinar && (
        <WebinarDialog isOpen={isOpen} onClose={closeWebinarDialog} />
      )}
    </>
  );
}

export default App;
